<template>
  <coverage-page
    :customPageControl="pageControl"
    :customDefaultForm="defaultForm"
    :customNeedValidate="needValidate"
  />
</template>
<script>
import { mapGetters } from "vuex";
import CoveragePage from "./components/CoveragePage.vue";
import { commonMixin } from "@/mixins/common";
export default {
  mixins: [commonMixin],
  name: "PermanentDisabilityBenefit",
  components: {
    CoveragePage,
  },
  data() {
    return {
      pageControl: {
        pageName: "傷害喪失工作能力保險",
        pageBlock: ["period", "formula", "maxCustom"],
        coverageParentCategories: ["傷害失能保險"],
        showUpper: true,
      },
      defaultForm: {
        unit_lower: 2,
      },
      needValidate: {
        period_upper: false,
      },
    };
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  watch: {},
  methods: {},
  mount() {},
};
</script>
